import { OVERVIEW_BUCKETS } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getComplianceOverviewCounts } from './compliance-overview.api';

/** Documents needing attention, for the sidebar badge (gitaumoses4/chukua#18): every bucket is an exception, so the total is the row count of the overview. Null until known or when unavailable — no badge beats a wrong one. */
export function useComplianceAttentionCount(enabled: boolean): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    getComplianceOverviewCounts()
      .then((counts) => {
        if (!cancelled) setCount(OVERVIEW_BUCKETS.reduce((total, bucket) => total + counts[bucket], 0));
      })
      .catch(() => {
        if (!cancelled) setCount(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return count;
}
